// WinnersHomeCities.jsx

import React, { useEffect, useState } from "react";
import "./WinnersHomeCitiesNew.css";

import HomeService from "../../../Services/HomeService";

import { useNavigate } from "react-router-dom";

import {
  HiOutlineLocationMarker,
} from "react-icons/hi";

import {
  FaArrowRightLong,
} from "react-icons/fa6";

const NewWinnerHomeCities = ({
  allowedCities,
  title,
}) => {

  const navigate = useNavigate();

  const [loginProfile, setLoginProfile] =
    useState(null);

  const [cities, setCities] =
    useState([]);

  const [userId, setUserId] =
    useState(null);

  /* =========================
     LOGIN PROFILE
  ========================= */

  useEffect(() => {

    const getLoginProfile = async () => {

      try {

        const res =
          await HomeService.getLoginProfile();

        console.log(
          "login profile",
          res
        );

        if (res?.status) {

          setLoginProfile(res?.data);

          setUserId(res?.data?._id);

        }

      } catch (error) {

        console.log(error);

      }
    };

    getLoginProfile();

  }, []);

  /* =========================
     GET ALL CITIES
  ========================= */

  const getAllCity = async () => {

    try {

      const res =
        await HomeService.getAllCities();

      console.log(
        "cities",
        res
      );

      if (res?.data) {

        setCities(res?.data);

      }

    } catch (error) {

      console.log(error);

    }
  };

  useEffect(() => {

    getAllCity();

  }, []);

  /* =========================
     HANDLE CITY
  ========================= */

  const handleCityFilter = (
    userID,
    ele
  ) => {

    if (
      title === "Working in cities"
    ) {

      if (
        loginProfile === null
      ) {

        navigate("/profile");

        return;
      }

      navigate("/propertyList", {
        state: {
          cityId: ele?._id,
          loggedInUserId: userID,
        },
      });
    }
  };

  return (

    <section className="winnercitynew-main-section">

      {/* TOP */}

      <div className="winnercitynew-top-wrapper">

        <div>

          <span className="winnercitynew-subtitle">
            Explore Prime Locations
          </span>

          <h2 className="winnercitynew-title">
            {title ||
              "Popular Cities"}
          </h2>

        </div>

      </div>

      {/* GRID */}

      <div className="winnercitynew-grid-wrapper">

        {(allowedCities?.length
          ? cities?.filter((e) =>
              allowedCities
                ?.map((city) =>
                  city
                    ?.trim()
                    ?.toLowerCase()
                )
                ?.includes(
                  e?.name
                    ?.trim()
                    ?.toLowerCase()
                )
            )
          : cities
        )?.map((e, i) => (

          <div
            key={i}
            className="winnercitynew-card"
            onClick={() =>
              handleCityFilter(
                userId,
                e
              )
            }
            style={{
              cursor:
                title ===
                "Working in cities"
                  ? "pointer"
                  : "default",
            }}
          >

            {/* IMAGE */}

            <div className="winnercitynew-image-wrapper">

              <img
                src={e?.image}
                alt={e?.name}
              />

              <div className="winnercitynew-overlay"></div>

              {/* LOCATION */}

              <div className="winnercitynew-location-badge">

                <HiOutlineLocationMarker />

                <span>
                  Premium Area
                </span>

              </div>

            </div>

            {/* CONTENT */}

            <div className="winnercitynew-content">

              <h3>
                {e?.name}
              </h3>

              <p>
                Explore luxury homes,
                premium apartments &
                smart investment
                opportunities in{" "}
                {e?.name}.
              </p>

              {/* BOTTOM */}

              <div className="winnercitynew-bottom">

                <div>

                  <h4>
                    {i + 10}K+
                  </h4>

                  <span>
                    Properties
                  </span>

                </div>

                <div className="winnercitynew-arrow">

                  <FaArrowRightLong />

                </div>

              </div>

            </div>

          </div>

        ))}

      </div>

    </section>
  );
};

export default NewWinnerHomeCities;